// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2Xf1l","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__hcU2P"};